import React from "react";
import ActionTop from "../../components/common/ActionTop";
import CollectinoItem from "../../components/common/CollectinoItem";
import LoadMore from "../../components/common/LoadMore";
import { collection } from "../../data/Data";

const HotCollections = () => {
  return (
    <>
      <section className="hot-collection">
        <div className="container">
          <h2 className="pageTitle">
            Hot Collecti<span>on</span>
          </h2>
          <div className="hot-collection-wrapper">
            <ActionTop />
            <div className="hot-collection-content">
              {collection.map((perCollection) => {
                return (
                  <CollectinoItem
                    perCollection={perCollection}
                    key={perCollection.id}
                  />
                );
              })}
            </div>
            <LoadMore btnTitle="Load more Collections" />
          </div>
        </div>
      </section>
    </>
  );
};

export default HotCollections;
